import React from "react";
import { Card, Table } from "react-bootstrap";
import DateRenderer from "./renderers/DateRenderer";
import { SortProvider } from "../services/SortingProvider";

interface HoldsViewProps
{
    data: Holds;
}

interface HoldsViewState
{
    data: Holds;
    sortAsc: boolean;
    sortIcon: string;
}

export default class HoldsView extends React.Component<HoldsViewProps, HoldsViewState>
{
    sortProvider: SortProvider

    constructor(props: HoldsViewProps)
    {
        super(props)

        this.sortProvider = new SortProvider(); 

        this.sortProvider.sort(this.props.data.holds, "Desc");

        this.state = {
            data: this.props.data,
            sortAsc: false,
            sortIcon: "fas fa-sort-down"
        };
    }

    render(): React.ReactNode
    {
        const sort = (): void =>
        {
            const sortedData = this.sortProvider.sort(this.state.data.holds, this.state.sortAsc ? "Desc" : "Asc");
            this.setState({ data: { holds: sortedData }, sortAsc: !this.state.sortAsc, sortIcon: this.state.sortAsc ? "fas fa-sort-down" : "fas fa-sort-up" });
        };

        return <div>
            <h2>Holds</h2>
            {
                (this.props.data.holds && this.props.data.holds.length > 0)
                    ?
                    <Card className={"border mb-3"}>
                        <Table className="list" responsive>
                            <thead>
                                <tr>
                                    <th>DESCRIPTION</th>
                                    <th>TYPE</th>
                                    <th>FROM</th>
                                    <th style={{ cursor: "pointer" }} onClick={sort}>TO <i className={this.state.sortIcon}></i></th>
                                    <th>NOTES</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.props.data.holds.map((hold: Hold, i: number) => 
                                    {
                                        return <tr key={i}>
                                            <td><b>{hold.description ? hold.description : " - "}</b></td>
                                            <td className="td-normal">{hold.type ? hold.type : " - "}</td>
                                            <td className="td-normal"><DateRenderer value={hold.fromDate} type={"short"} /></td>
                                            <td className="td-normal"><DateRenderer value={hold.toDate} type={"short"} /></td>
                                            <td className="td-normal">{hold.notes ? hold.notes : " - "}</td>
                                        </tr>;
                                    })
                                }
                            </tbody>
                        </Table>
                    </Card>
                    :
                    <div id='error'>
                        <Card className={"border mb-3"}>
                            <Table responsive className="list">
                                <thead>
                                    <tr>
                                        <th>DESCRIPTION</th>
                                        <th>TYPE</th>
                                        <th>FROM</th>
                                        <th>TO</th>
                                        <th>NOTES</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="text-center">
                                        <td colSpan={5}>
                                            <p className="error-text">No Holds data available</p>
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Card>
                    </div>
            }
        </div>;
    }
}